import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.less'],
})
export class ApprovalComponent implements OnInit {
  @Input() data: Array<object>;
  @Input() nowStep: number = 1;

  constructor() {}

  ngOnInit(): void {}
}
